export default defineNuxtRouteMiddleware((to, from) => {
  const { t } = useNuxtApp().$i18n
  const dayjs = useDayjs()
  const app = useAppStore()
  const fat = useFatStore()

  // Check if request is inital pageview
  const initialPageview = app.pageviews === 0

  // Reset Restaurant ID's when entering FAT
  if (to.name === 'fat' && fat.restaurantIds?.length) {
    fat.restaurantIds = []
  }

  // Spread query params
  const { 
    date, 
    amount, 
    cityId, 
    location,
    mode,
    excludeEmpty, 
    timeRange, 
    mealTypeIds,
    tagIds,
    s
  } = to.query

  // Check if date has passed
  if (date && dayjs().isAfter(date, 'day')) {
    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        date: dayjs().format('YYYY-MM-DD')
      }
    })
  }

  // Reset map mode on initial load
  if (mode && initialPageview) {
    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        mode: undefined
      }
    })
  }

  // Reset city ID if location is defined
  if (location && cityId) {
    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        cityId: undefined,
      }
    })
  }

  // Set city ID
  if (!cityId && !location) {
    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        cityId: fat.cityId || 86915,
      }
    })
  }

  // Set default date
  if (!date) {
    return navigateTo({
      path: to.path,
      query: {
        date: fat.date,
        ...to.query,
      }
    })
  }

  // Set default amount
  if (!amount) {
    return navigateTo({
      path: to.path,
      query: {
        amount: fat.amount,
        ...to.query,
      }
    })
  }

  // Set default excludeEmpty
  if (!excludeEmpty) {
    return navigateTo({
      path: to.path,
      query: {
        excludeEmpty: fat.excludeEmpty,
        ...to.query,
      }
    })
  }

  // Set City ID
  fat.cityId = parseInt(cityId || fat.cityId || 86915)
  
  // Set Date
  fat.date = date || dayjs().format('YYYY-MM-DD')
  
  // Set Amount
  fat.amount = parseInt(amount || 2)

  // Set location 
  const locationParts = location?.split(',')
  fat.latitude = location ? parseFloat(locationParts[0]) : null
  fat.longitude = location ? parseFloat(locationParts[1]) : null
  fat.distance = location ? parseInt(locationParts[2]) : 3000
  
  // Set Exclude Empty
  fat.excludeEmpty = excludeEmpty === 'false' ? false : true

  // Set Start and End Time
  const times = timeRange?.split('-')
  const startTime = timeRange ? times[0] : fat.startTime
  const endTime = timeRange ? times[1] : fat.endTime
  fat.setTimeRange(startTime, endTime)

  // Set Meal Types
  fat.mealTypeIds = mealTypeIds?.length 
    ? mealTypeIds?.split(',')?.map(id => parseInt(id))
    : []

  // Set Tag ID's
  fat.tagIds = tagIds?.length 
    ? tagIds?.split(',')?.map(id => parseInt(id))
    : []

  // Set Search String
  fat.s = !!s ? s.toString() : ''
})